// extracted by mini-css-extract-plugin
module.exports = {"profileButton":"avatarOld_profileButton__2a5wD","spyIcon":"avatarOld_spyIcon__3bOT7"};